var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-cloud-3"},[_c('div',{staticClass:"background-cloud-top"}),_vm._v(" "),_c('div',{staticClass:"background-cloud-bottom"})])
}]

export { render, staticRenderFns }